import React from 'react';

import { isHoliday } from 'nyse-holidays';
import Marquee from 'react-fast-marquee';

const isTradingDay = () => {
  const today = new Date();
  const day = today.getDay(); // 0 = Sunday, 6 = Saturday

  // Return false for weekends or NYSE holidays
  return day !== 0 && day !== 6 && !isHoliday(today);
};

const StockTicker = ({
  stocks,
  isLogged,
}: {
  stocks: { symbol: string; change: number }[];
}) => {
  if (!(stocks || []).length) return null; // Hide ticker if no stocks available

  return (
    <div
      hidden={!isTradingDay()}
      style={{
        backgroundColor: isLogged ? '' : '#21272C',
        borderTop: '2px solid #4A90E2',
        padding: '0 0 0 0',
      }}
    >
      {/* Duplicate the stock array to ensure continuous scrolling */}
      <Marquee gradient={false} speed={20} loop={0} direction="left">
        {[...stocks, ...stocks].map((stock, index) => {
          const changeValue = Number(stock.change); // Ensure change is a valid number
          return (
            <span
              key={index}
              style={{
                fontSize: '14px',
                fontWeight: 'bold',
                color: isLogged ? 'var(--whitecolor)' : 'white',
                marginRight: '15px',
              }}
            >
              {stock.symbol} &nbsp;&nbsp;
              <span style={{ color: changeValue >= 0 ? 'green' : 'red' }}>
                {isNaN(changeValue) ? 'N/A' : changeValue.toFixed(2)}%
              </span>
              <span style={{ margin: '0 10px', color: '#AAA' }}>|</span>
            </span>
          );
        })}
      </Marquee>
    </div>
  );
};

export default StockTicker;
